var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getFlag('cohorts-show-pinned'))?_c('OutlinedIcon',{on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('v-icon',{attrs:{"color":_vm.value ? 'black' : '#b0b3b6',"small":""}},[_vm._v("mdi-pin")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }